// Methods
import { cutParamFromUrl } from './utils/cutParamFromUrl';

// Utils
import { debug } from './utils/debug.js';

// Constants
import { PARAM_NAMES, SZNTIME_VALIDITY_THRESHOLD } from '../config.js';

/**
 * Attempts to retrieve SZNTIME from URL.
 * @return {Number | null} SZNTIME or null if no szntime in URL.
 */
export const getSzntime = () => {
  debug({
    message: 'getting SZNTIME',
    state: 'running',
    szntime: {
      state: 'start',
    },
  });

  const szntime = cutParamFromUrl(window.location.href, PARAM_NAMES.SZNTIME);

  if (!szntime) {
    debug({
      state: 'running',
      message: 'did not find szntime in url',
      szntime: {
        state: 'done',
        error: 'no szntime in URL',
        szntime,
      },
    });
    return null;
  }

  debug({
    state: 'running',
    message: 'successfully retrieved "szntime"',
    szntime: {
      state: 'done',
      szntime,
    },
  });
  return Number(szntime);
};

/**
 * Check whether given SZNTIME is still fresh (CURRENT_TIME - SZNTIME < THRESHOLD)
 * @param szntime {Number | null} SZNTIME
 */
export const isSzntimeValid = (szntime) => {
  const currTime = Date.now() / 1000;
  const diff = Math.abs(szntime - currTime);

  if (diff >= SZNTIME_VALIDITY_THRESHOLD) {
    debug({
      state: 'running',
      message: `szntime threshold exceeded: ${diff}`,
      szntime: {
        state: 'done',
        error: `szntime threshold exceeded: ${diff}`,
        szntime,
      },
    });
    return false;
  }

  debug({
    state: 'running',
    message: 'szntime threshold within limit',
    szntime: {
      state: 'done',
      szntime,
    },
  });
  return true;
};
